import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
    pulse?: boolean
}

// Approdo mark: a peak that lands on a shoreline, the job you reach and the place you arrive
export const BrandMark: FC<BrandMarkProps> = ({ className, pulse = false }): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn('relative inline-flex aspect-square shrink-0 items-center justify-center overflow-hidden rounded-[30%] bg-ink', className)}
        >
            {pulse && <span className='absolute inset-[30%] animate-blip rounded-full bg-brand/50' />}

            <svg viewBox='0 0 48 48' fill='none' className='relative size-full'>
                <path d='M14.5 31 24 15l9.5 16' stroke='#f26b3a' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M11 36.5h26' stroke='#fbf1e9' strokeWidth='3.5' strokeLinecap='round' />
            </svg>
        </span>
    )
}
